import type { AppState } from '../state/appState.js';
import type { GeometrySlot, MaterialSlot } from '../scene/layerState.js';

export type LibraryKind = 'geometry' | 'material';
export type EditorLibraryKind = LibraryKind;
export type SlotValue = GeometrySlot | MaterialSlot;

export interface ReturnToSceneOptions {
  openScenePanel?: boolean;
}

export function libraryNameFor(appState: AppState, kind: LibraryKind, id: string): string {
  const item = kind === 'geometry'
    ? (appState.geometryLibrary.builtIn[id] ?? appState.geometryLibrary.user[id])
    : (appState.materialLibrary.builtIn[id] ?? appState.materialLibrary.user[id]);
  return item?.name ?? id;
}

export function getSlotStateFor(
  appState: AppState,
  kind: LibraryKind,
  slot: SlotValue,
): { status: string; detail: string } {
  if (slot.type === 'inline') {
    return {
      status: 'Inline',
      detail: 'Inline',
    };
  }

  return {
    status: 'Library',
    detail: libraryNameFor(appState, kind, slot.id),
  };
}
